import React from 'react';
import LocationTemplate from './LocationTemplate';

const CreswellPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Creswell"
      stateName="North Carolina"
      countyName="Washington"
      zipCodes={["27928"]}
      latitude={35.8799}
      longitude={-76.3841}
      population={274}
      historicalFact="Incorporated in 1891, named after Creswell family who were early settlers in the area."
      nearbyTowns={[
        "Plymouth, NC",
        "Columbia, NC",
        "Roper, NC",
        "Washington, NC",
        "Williamston, NC",
        "Jamesville, NC",
        "Edenton, NC",
        "Pantego, NC"
      ]}
    />
  );
};

export default CreswellPage;